import React, { useEffect, useState } from "react";
import { FaAngleDown, FaRegThumbsUp } from "react-icons/fa";
import { Link, useLocation, useParams } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import {
  Container,
  Row,
  Col,
  Form,
  InputGroup,
  FormControl,
  Nav,
  Modal,
  Tab,
  Card,
  Button,
} from "react-bootstrap";
import dayjs from "dayjs";
import "dayjs/locale/en-gb";
import { HiPlusSmall } from "react-icons/hi2";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { HiMiniMinusSmall } from "react-icons/hi2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
// import DepatureDetail from "./DepartureDetail";
// import FlightDetailSkeleton from "./FlightDetailSkeleton";
import GoodToKnow from "../../../FlightDetails/GoodToKnow";
import FareRule from "../../../FlightDetails/FareRule";
// import { cities2 } from "../../Cities";
// import { cities2 } from "../../../../Cities";
import ChargesOneWay from "../../../FlightDetails/ChargesOneWay";
import BDSend from "../../../FlightDetails/BDSend";
import FlightPayModal from "./FlightPayModal";
import ChargesRound from "../../../FlightDetails/ChargesRound";
import SSRContent from "../../../FlightDetails/SSRContent";
import TravellerInformation from "./TravellerInformation";
import DepatureDetail from "./DepartureDetail";
import FlightDetailSkeleton from "../../../FlightDetails/FlightDetailSkeleton";
import PriceDetail from "./PriceDetail";
import { Markup } from "../../../../redux/services/operations/markup";
import { FaClock } from "react-icons/fa6";
import { resetTimer } from "../../../../redux/slices/flightSlice";
import { toast } from "react-toastify";
import { TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers";

import "dayjs/locale/en-gb";
import { countries } from "../../../../Countries";


const FlightInternationalDetail = () => {
  const dispatch = useDispatch();
  const { walletData } = useSelector((state) => state.auth);
  const [walletDatas, setWalletDatas] = useState(0);
  const [creditLimits, setCreditLimits] = useState(0);
  useEffect(() => {
    const data = localStorage.getItem("walletBalance");
    const datas = localStorage.getItem("CreditLimit");
    if (data) {
      setWalletDatas(data);
    }
    if (datas) {
      setCreditLimits(datas);
    }

    const dataaaa = {
      AgentId: walletData.Id,
    };

    dispatch(Markup(dataaaa));
  }, []);
  const { adminIm, agentIm } = useSelector((state) => state.markUp);
  const [openPayBtn, setOpenPayBtn] = useState(false);
  const decodedIndex = decodeURIComponent(useParams().index);
const[loading,setLoading]=useState(false)
  const [searched, setSearched] = useState(null);
  const [fareRule, setFareRule] = useState(null);
  const [ssrResponse, setSsrResponse] = useState(null);
  const [flight, setFlight] = useState(null);
  const [flight2, setFlight2] = useState(null);
  const [fareRule2, setFareRule2] = useState(null);
  const [ssrResponse2, setSsrResponse2] = useState(null);
  const [emiBtn, setEmiBtn] = useState(false);
  const search = useSelector((state) => state.flight.search);
  const [passengerBaggagePreferences, setPassengerBaggagePreferences] =
    useState([]);
  const [passengerSeatPreferences, setPassengerSeatPreferences] = useState([]);
  const [passengerMealPreferences, setPassengerMealPreferences] = useState([]);
  const [token, setToken] = useState();
  const [bookingKey, setBookingKey] = useState();
  const [fareActive, setFareActive] = useState(true);

  const parseFareRule = (fareRuleDetail) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = fareRuleDetail;
    const listItems = Array.from(tempDiv.querySelectorAll("li")).map((li) =>
      li.textContent.trim()
    );

    return listItems;
  };
  const storedBookingKey = String(sessionStorage.getItem("bookingId"));
  const storedToken = String(localStorage.getItem("token"));
  const [tokenss, setTokenss] = useState(storedToken);
  const [bookingKeyss, setBookingKeyss] = useState(storedBookingKey);

  const timer = useSelector((state) => state.flight.timer);
  const [showsessionModal, setShowsessionModal] = useState(false);

  // Effect to open the modal when the timer hits 0
  useEffect(() => {
    if (timer.minutes === 0 && timer.seconds === 0) {
      setShowsessionModal(true);
    }
  }, [timer]);

  // Function to handle closing the modal and resetting the timer or starting a new search
  const handleOk = () => {
    setShowsessionModal(false);
    dispatch(resetTimer());
    navigate(-1, { replace: true });
    // Optionally, navigate to the search page or trigger a new search
  };

  useEffect(() => {
    const storedBookingKey = String(sessionStorage.getItem("bookingId"));
    const storedToken = String(localStorage.getItem("token"));

    if (storedBookingKey && storedToken) {
      setBookingKey(storedBookingKey);
      setToken(storedToken);
    } else {
      setBookingKey(undefined);
      setToken(undefined);
    }
    console.log("TOKENNNN", token);
    console.log("bookinggggg", bookingKey);
    console.log("DECODE!", decodedIndex);

    const fetchData = async () => {
      try {
        const response1 = await axios.post(
          "https://admin.yatriservice.com/api/flightfarerule",
          {
            // APIToken: token || tokenss,
            Id:walletData.Email,
            BookingKey: bookingKey || bookingKeyss,
            ContractId: decodedIndex,
          }
        );
        console.log("RESPONSE @@@@ 2222", response1);
        setFareActive(true);
        const response2 = await axios.post(
          "https://admin.yatriservice.com/api/flightsell",
          {
            // APIToken: token || tokenss,
            Id:walletData.Email,
            BookingKey: bookingKey || bookingKeyss,
            ContractId: decodedIndex,
          }
        );
        console.log("DATA IN INTERNTATION DAYY", {
          APIToken: token || tokenss,
          BookingKey: bookingKey || bookingKeyss,
          ContractId: parseInt(decodedIndex),
        });
        console.log("RESPONSE @@@@ 2222", response2);
        if (response2.data.success) {
          setFareActive(false);
        }

        // setSearched(response2.data.data.Sell);

        // if (response2.data.success) {
        //   const originDestinationOptions =
        //     response2.data.data.Sell && response2.data.data.Sell.Contracts[0];

        //   originDestinationOptions &&
        //     originDestinationOptions.Contracts[0].AirSegments.forEach(
        //       (segment) => {
        //         const departureCode = segment.Origen;
        //         const arrivalCode = segment.Destination;

        //         const departureCity = cities2.find(
        //           (city) => city.AIRPORTCODE === departureCode
        //         );
        //         const arrivalCity = cities2.find(
        //           (city) => city.AIRPORTCODE === arrivalCode
        //         );

        //         segment.DepartureCity = departureCity;
        //         segment.ArrivalCity = arrivalCity;
        //       }
        //     );
        //   // if (decodedIndex2 !== "" && decodedIndex2 !== "undefined") {
        //   //   const originDestinationOptions2 =
        //   //     response2.data.data.Sell &&
        //   //     response2.data.data.Sell.Contracts[1].AirSegments;

        //   //   originDestinationOptions2 &&
        //   //     originDestinationOptions2.forEach((segment) => {
        //   //       const departureCode = segment.Origen;
        //   //       const arrivalCode = segment.Destination;

        //   //       const departureCity = cities2.find(
        //   //         (city) => city.AIRPORTCODE === departureCode
        //   //       );
        //   //       const arrivalCity = cities2.find(
        //   //         (city) => city.AIRPORTCODE === arrivalCode
        //   //       );

        //   //       segment.DepartureCity = departureCity;
        //   //       segment.ArrivalCity = arrivalCity;
        //   //     });
        //   // }
        //   // setFlight(response2.data.data.Sell);
        // }
        // console.log("response1", response1);
        // console.log("response2", response2);
        // console.log("response12", response12);

        setSearched(response2.data.data.Sell);
        // setFlight2(response2.data.data.Sell.Contracts[1]);

        setFareRule(response1.data.data.FareRule);
        const newPassengers =
          response2.data.data.Sell &&
          response2.data.data.Sell.Contracts[0].PexFareDetails.flatMap(
            ({ PaxType, TotPax }) => {
              const typeLabel =
                PaxType === 1 ? "Adult" : PaxType === 2 ? "Child" : "Infant";
              return Array.from({ length: TotPax }, (_, index) => ({
                id: index + 1,
                type: typeLabel,
                name: `Passenger ${index + 1}`,
              }));
            }
          );

        setPassengers(newPassengers);
        console.log("newPassenger", newPassengers);
      } catch (error) {
        console.error("Error fetching flight data:", error);
      }
    };
 
    fetchData();
   
  }, [decodedIndex, token, bookingKey]);
  console.log("FLEIWGIBFI", searched);
  console.log("FARE RULE", fareRule);

  const restructureSegments = (search) => {
    return (
      searched &&
      searched.Contracts.map((item) => {
        const onwardSegments = item.AirSegments.filter(
          (segment) => segment.SegmentType === "Onword"
        );
        const returnSegments = item.AirSegments.filter(
          (segment) => segment.SegmentType === "Return"
        );
        return {
          ...item,
          AirSegments: [onwardSegments, returnSegments],
        };
      })
    );
  };

  useEffect(() => {
    if (searched) {
      const data = restructureSegments(searched);
      setFlight(data);
      console.log("SERCHED UFFERECT DATA", data);
    }
  }, [searched]);
  const [internationalMarkup, setInternationalMarkup] = useState(0);
  useEffect(() => {
    const storedFare = localStorage.getItem("add-int");

    if (storedFare) {
      let finalPrice =
        storedFare !== undefined && storedFare !== null ? storedFare : 0;
      setInternationalMarkup(parseInt(finalPrice));
    } else {
      setInternationalMarkup(0);
    }
  }, [searched]);
  console.log("FLEIWGIBFIwreyttrhrthrthtrhgrthbrtghrthbgrt6dgh", flight);
  const [promoCode, setPromoCode] = useState("");
  const [appliedCode, setAppliedCode] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const handleApply = () => {
    // Apply logic here
    setAppliedCode(promoCode);
    setSuccessMessage("Promo code applied successfully!");
    setPromoCode("");
  };

  const handleClear = () => {
    // Clear logic here
    setAppliedCode("");
    setSuccessMessage("");
  };

  const navigate = useNavigate();
  const handlePayment = () => {
    navigate("/agent/flight-ticket");
  };

  const formatTime = (arrTime) => {
    const date = new Date(arrTime);
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const day = days[date.getDay()];
    const dateNum = String(date.getDate()).padStart(2, "0");
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    return `${day}, ${dateNum} ${month} ${year}`;
  };

  const [showdetail, setShowdetail] = useState(false);

  const [activeTab, setActiveTab] = useState(0);
  const [passengers, setPassengers] = useState([]);

  const handleTabChange = (index) => {
    setActiveTab(index);
  };

  const [formData, setFormData] = useState([]);
  const [childData, setChildData] = useState([]);
  const [infant, setInfant] = useState([]);

  // const handleInputChange = (index, e) => {
  //   const { name, value } = e.target;
  //   const cleanedName = name.replace(/\d+/g, "");
  //   const list = [...formData];
  //   if (!list[index]) {
  //     list[index] = {};
  //   }
  //   list[index][cleanedName] = value;
  //   setFormData(list);
  //   console.log("adultdata", formData);
  // };

  // const handleInputChange1 = (index, e) => {
  //   const { name, value } = e.target;
  //   const cleanedName = name.replace(/\d+/g, "");

  //   const list = [...childData];
  //   if (!list[index]) {
  //     list[index] = {};
  //   }
  //   list[index][cleanedName] = value;
  //   setChildData(list);
  // };
  // const handleInputChange = (index, e) => {
  //   const { name, value } = e.target;
  //   const cleanedName = name.replace(/\d+/g, "");
  //   const list = [...formData];

  //   // Function to convert the date from YYYY-MM-DD to DD-MM-YYYY
  //   const formatDate = (date) => {
  //     const [year, month, day] = date.split("-");
  //     return `${day}-${month}-${year}`;
  //   };

  //   // Check if the field is the expiry date and format it
  //   let formattedValue = value;
  //   if (cleanedName === "expirydate") {
  //     formattedValue = formatDate(value);
  //   }

  //   if (!list[index]) {
  //     list[index] = {};
  //   }

  //   list[index][cleanedName] = formattedValue; // Set the formatted date or other values
  //   setFormData(list);

  //   console.log("adultdata", formData);
  // };

  // const handleInputChange1 = (index, e) => {
  //   const { name, value } = e.target;
  //   const cleanedName = name.replace(/\d+/g, "");

  //   const list = [...childData];

  //   // Function to convert the date from YYYY-MM-DD to DD-MM-YYYY
  //   const formatDate = (date) => {
  //     const [year, month, day] = date.split("-");
  //     return `${day}-${month}-${year}`;
  //   };

  //   // Check if the field is the expiry date and format it
  //   let formattedValue = value;
  //   if (cleanedName === "expirydate") {
  //     formattedValue = formatDate(value);
  //   }

  //   if (!list[index]) {
  //     list[index] = {};
  //   }

  //   list[index][cleanedName] = formattedValue; // Set the formatted date or other values
  //   setChildData(list);
  // };

  // const handleInputChange2 = (index, e) => {
  //   const { name, value } = e.target;
  //   const cleanedName = name.replace(/\d+/g, "");

  //   const list = [...infant];
  //   if (!list[index]) {
  //     list[index] = {};
  //   }
  //   list[index][cleanedName] = value;
  //   setInfant(list);
  // };

  const handleInputChange = (index, e) => {
    const { name, value } = e.target;
    const cleanedName = name.replace(/\d+/g, ""); // Remove numeric parts from the name

    // Create a copy of the current formData
    const list = [...formData];

    // Ensure the index exists in the list
    if (!list[index]) {
      list[index] = {};
    }

    // Handle date-specific validation and formatting if the field is for a date
    if (cleanedName === "date" && dayjs(value).isValid()) {
      // Save the date in YYYY-MM-DD format
      list[index][cleanedName] = dayjs(value).format("YYYY-MM-DD");
    } else if (cleanedName !== "date") {
      // For other fields, save the raw value
      list[index][cleanedName] = value;
    } else {
      // Log an invalid date input
      console.log("Invalid date");
    }

    // Update the formData state
    setFormData(list);
    console.log("Updated formData:", formData);
  };
  const handleInputChange1 = (index, e) => {
    const { name, value } = e.target;
    const cleanedName = name.replace(/\d+/g, ""); // Remove numeric parts from the name

    // Create a copy of the current formData
    const list = [...childData];

    // Ensure the index exists in the list
    if (!list[index]) {
      list[index] = {};
    }

    // Handle date-specific validation and formatting if the field is for a date
    if (cleanedName === "date" && dayjs(value).isValid()) {
      // Save the date in YYYY-MM-DD format
      list[index][cleanedName] = dayjs(value).format("YYYY-MM-DD");
    } else if (cleanedName !== "date") {
      // For other fields, save the raw value
      list[index][cleanedName] = value;
    } else {
      // Log an invalid date input
      console.log("Invalid date");
    }

    // Update the formData state
    setChildData(list);
    console.log("Updated formData:", formData);
  };
  const handleInputChange2 = (index, e) => {
    const { name, value } = e.target;
    const cleanedName = name.replace(/\d+/g, ""); // Remove numeric parts from the name

    // Create a copy of the current formData
    const list = [...infant];

    // Ensure the index exists in the list
    if (!list[index]) {
      list[index] = {};
    }

    // Handle date-specific validation and formatting if the field is for a date
    if (cleanedName === "date" && dayjs(value).isValid()) {
      // Save the date in YYYY-MM-DD format
      list[index][cleanedName] = dayjs(value).format("YYYY-MM-DD");
    } else if (cleanedName !== "date") {
      // For other fields, save the raw value
      list[index][cleanedName] = value;
    } else {
      // Log an invalid date input
      console.log("Invalid date");
    }

    // Update the formData state
    setInfant(list);
    console.log("Updated formData:", formData);
  };

  const isValidExpiryDate = (index, date) => {
    const flightArrTime = new Date(
      flight[0].AirSegments[1][
        flight[0].AirSegments[1].length - 1
      ].ArrivalDateTime
    );

    const expiryDate = new Date(date);

    const sixMonthsAfterArrTime = new Date(
      flightArrTime.setMonth(flightArrTime.getMonth() + 6)
    );

    return expiryDate >= sixMonthsAfterArrTime;
  };

  const handleExpiryDateChange = (index, e) => {
    const { value } = e.target;
    if (!isValidExpiryDate(index, value)) {
      alert("The expiry date must be at least 6 months after the flight date.");
    } else {
      handleInputChange(index, e);
    }
  };

  const handleExpiryDateChange1 = (index, e) => {
    const { value } = e.target;
    if (!isValidExpiryDate(index, value)) {
      alert("The expiry date must be at least 6 months after the flight date.");
    } else {
      handleInputChange1(index, e);
    }
  };

  const handleExpiryDateChange2 = (index, e) => {
    const { value } = e.target;
    if (!isValidExpiryDate(index, value)) {
      alert("The expiry date must be at least 6 months after the flight date.");
    } else {
      handleInputChange2(index, e);
    }
  };

  const isValidDateOfBirth = (date) => {
    const currentDate = new Date();
    const dob = new Date(date);
    let age = currentDate.getFullYear() - dob.getFullYear();
    const monthDiff = currentDate.getMonth() - dob.getMonth();

    if (
      monthDiff < 0 ||
      (monthDiff === 0 && currentDate.getDate() < dob.getDate())
    ) {
      age--;
    }

    return age >= 12;
  };

  const isValidDateOfBirth1 = (date) => {
    const currentDate = new Date();
    const dob = new Date(date);
    let age = currentDate.getFullYear() - dob.getFullYear();
    const monthDiff = currentDate.getMonth() - dob.getMonth();

    if (
      monthDiff < 0 ||
      (monthDiff === 0 && currentDate.getDate() < dob.getDate())
    ) {
      age--;
    }

    return age >= 2 && age < 12;
  };

  const isValidDateOfBirth2 = (date) => {
    const currentDate = new Date();
    const dob = new Date(date);
    let age = currentDate.getFullYear() - dob.getFullYear();
    const monthDiff = currentDate.getMonth() - dob.getMonth();

    if (
      monthDiff < 0 ||
      (monthDiff === 0 && currentDate.getDate() < dob.getDate())
    ) {
      age--;
    }

    return age < 2;
  };

  const handleDOBChange = (index, e) => {
    const { value } = e.target;
    if (!isValidDateOfBirth(value)) {
      alert("The age must be greater than 12 years.");
    } else {
      handleInputChange(index, e);
    }
  };

  const handleDOBChange1 = (index, e) => {
    const { value } = e.target;
    if (!isValidDateOfBirth1(value)) {
      alert("The age must be between 2 to 12 years.");
    } else {
      handleInputChange1(index, e);
    }
  };

  const handleDOBChange2 = (index, e) => {
    const { value } = e.target;
    if (!isValidDateOfBirth2(value)) {
      alert("The age must be less than 2 years.");
    } else {
      handleInputChange2(index, e);
    }
  };




  const totalPassengers =
  (flight) &&
  flight[0].PexFareDetails.reduce(
    (sum, detail) => sum + (detail.TotPax || 0),
    0
  );




  const [markups, setMarkups] = useState({ agent: [], admin: [] });
  useEffect(() => {
    const AgentId = walletData.Id;

    const fetchMarkups = async () => {
      try {
      
        const agentResponse = await axios.post(
          `https://admin.yatriservice.com/api/agent-markup/all`,
          { AgentId }
        );
        
        
        const adminResponse = await axios.post(
          `https://admin.yatriservice.com/api/markup`,
          { AgentId } // Assuming admin doesn't need an AgentId
        );

        if (agentResponse.data.success === true) {
          setMarkups((prevState) => ({
            ...prevState,
            agent: agentResponse.data.data || [],
          }));
          console.log("Agent Markup Response", agentResponse.data.data);
        }

        if (adminResponse.data.success === true) {
          setMarkups((prevState) => ({
            ...prevState,
            admin: adminResponse.data.data || [],
          }));
          console.log("Admin Markup Response", adminResponse.data.data);
        }
      } catch (error) {
        console.error("Error fetching markup data:", error);
      }
    };

    fetchMarkups();
  }, [walletData]);
  

  // const calculateFareDeduct = (baseFare, markups, totalPassengers, flightCode) => {
  //   const flightType = "international";
  
  //   const applicableAdminMarkups = markups?.admin?.filter(
  //     (markup) => markup.flight_type === flightType
  //   ) || [];
  
  //   if (applicableAdminMarkups.length === 0) {
  //     console.warn(`No applicable admin markups found for flight type: ${flightType}`);
  //     return baseFare; // No applicable admin markups, just return the base fare
  //   }
  
  //   const airlineWiseAdminMarkup = applicableAdminMarkups.find(
  //     (markup) =>
  //       markup.markup_type === "airline_wise" && markup.flight_code === flightCode
  //   );
  
  //   const generalAdminMarkup = applicableAdminMarkups.find(
  //     (markup) => markup.markup_type === "all"
  //   );
  
  //   const selectedAdminMarkup = airlineWiseAdminMarkup || generalAdminMarkup;
  
  //   let updatedFare = baseFare;
  
  //   if (selectedAdminMarkup) {
  //     if (selectedAdminMarkup.service_type === "fixed") {
  //       const totalServiceFee =
  //         parseFloat(selectedAdminMarkup.service_fee) * totalPassengers * 2; // Double the fee
  //       updatedFare += totalServiceFee; // Add total service fee for all passengers
  //     } else if (selectedAdminMarkup.service_type === "percentage") {
  //       const percentageFee =
  //         (baseFare * parseFloat(selectedAdminMarkup.service_fee)) / 100 * 2; // Double the fee
  //       updatedFare += percentageFee; // Add percentage fee for all passengers
  //     }
  //   }
  
  //   return parseInt(updatedFare); // Return the updated fare after applying doubled markup
  // };
  
  

  // const calculateFare = (baseFare, markups, totalPassengers, flightCode) => {
  //   const flightType = "international";
  
  //   const applicableAgentMarkups = markups?.agent?.filter(
  //     (markup) => markup.flight_type === flightType
  //   ) || [];
  
  //   const applicableAdminMarkups = markups?.admin?.filter(
  //     (markup) => markup.flight_type === flightType
  //   ) || [];
  
  //   if (
  //     (applicableAgentMarkups.length === 0 && applicableAdminMarkups.length === 0)
  //   ) {
  //     console.warn(`No applicable markups found for flight type: ${flightType}`);
  //     return baseFare;
  //   }
  
  //   const airlineWiseAgentMarkup = applicableAgentMarkups.find(
  //     (markup) =>
  //       markup.markup_type === "airline_wise" && markup.flight_code === flightCode
  //   );
  
  //   const airlineWiseAdminMarkup = applicableAdminMarkups.find(
  //     (markup) =>
  //       markup.markup_type === "airline_wise" && markup.flight_code === flightCode
  //   );
  
  //   const generalAgentMarkup = applicableAgentMarkups.find(
  //     (markup) => markup.markup_type === "all"
  //   );
  
  //   const generalAdminMarkup = applicableAdminMarkups.find(
  //     (markup) => markup.markup_type === "all"
  //   );
  
  //   const selectedAgentMarkup = airlineWiseAgentMarkup || generalAgentMarkup;
  //   const selectedAdminMarkup = airlineWiseAdminMarkup || generalAdminMarkup;
  
  //   let updatedFare = baseFare;
  
  //   if (selectedAgentMarkup) {
  //     if (selectedAgentMarkup.service_type === "fixed") {
  //       const totalServiceFee =
  //         parseFloat(selectedAgentMarkup.service_fee) * totalPassengers * 2; // doubled the fee
  //       updatedFare += totalServiceFee;
  //     } else if (selectedAgentMarkup.service_type === "percentage") {
  //       const percentageFee =
  //         (baseFare * parseFloat(selectedAgentMarkup.service_fee)) / 100 * 2; // doubled the fee
  //       updatedFare += percentageFee;
  //     }
  //   }
  
  //   if (selectedAdminMarkup) {
  //     if (selectedAdminMarkup.service_type === "fixed") {
  //       const totalServiceFee =
  //         parseFloat(selectedAdminMarkup.service_fee) * totalPassengers * 2; // doubled the fee
  //       updatedFare += totalServiceFee;
  //     } else if (selectedAdminMarkup.service_type === "percentage") {
  //       const percentageFee =
  //         (baseFare * parseFloat(selectedAdminMarkup.service_fee)) / 100 * 2; // doubled the fee
  //       updatedFare += percentageFee;
  //     }
  //   }
  
  //   return parseInt(updatedFare);
  // };
  
  // const calculateFares = (baseFare, markups, totalPassengers, flightCode) => {
  //   const flightType = "international";
  
  //   // Find applicable agent and admin markups
  //   const applicableAgentMarkups = markups.agent?.filter(
  //     (markup) => markup.flight_type === flightType
  //   ) || [];
  
  //   const applicableAdminMarkups = markups.admin?.filter(
  //     (markup) => markup.flight_type === flightType
  //   ) || [];
  
  //   // Find airline-specific and general markups
  //   const airlineWiseAgentMarkup = applicableAgentMarkups.find(
  //     (markup) =>
  //       markup.markup_type === "airline_wise" && markup.flight_code === flightCode
  //   );
  
  //   const airlineWiseAdminMarkup = applicableAdminMarkups.find(
  //     (markup) =>
  //       markup.markup_type === "airline_wise" && markup.flight_code === flightCode
  //   );
  
  //   const generalAgentMarkup = applicableAgentMarkups.find(
  //     (markup) => markup.markup_type === "all"
  //   );
  
  //   const generalAdminMarkup = applicableAdminMarkups.find(
  //     (markup) => markup.markup_type === "all"
  //   );
  
  //   // Prioritize airline-wise markup, then general markup
  //   const selectedAgentMarkup = airlineWiseAgentMarkup || generalAgentMarkup;
  //   const selectedAdminMarkup = airlineWiseAdminMarkup || generalAdminMarkup;
  
  //   if (!selectedAgentMarkup && !selectedAdminMarkup) {
  //     console.warn(`No markup found for flight type: ${flightType}`);
  //     return baseFare; // No markup found, just return the base fare
  //   }
  
  //   let updatedFare = baseFare; // Keep the base fare unchanged initially
  
  //   // Apply agent markup if available
  //   if (selectedAgentMarkup) {
  //     if (selectedAgentMarkup.service_type === "fixed") {
  //       // If agent markup is fixed
  //       const totalServiceFee =
  //         parseFloat(selectedAgentMarkup.service_fee) * totalPassengers * 2; // Double the fee
  //       updatedFare += totalServiceFee; // Add total service fee for all passengers
  //     } else if (selectedAgentMarkup.service_type === "percentage") {
  //       // If agent markup is percentage
  //       const percentageFee =
  //         (baseFare * parseFloat(selectedAgentMarkup.service_fee)) / 100 * 2; // Double the fee
  //       updatedFare += percentageFee; // Add percentage fee for all passengers
  //     }
  //   }
  
  //   // Apply admin markup if available
  //   if (selectedAdminMarkup) {
  //     if (selectedAdminMarkup.service_type === "fixed") {
  //       // If admin markup is fixed
  //       const totalServiceFee =
  //         parseFloat(selectedAdminMarkup.service_fee) * totalPassengers * 2; // Double the fee
  //       updatedFare += totalServiceFee; // Add total service fee for all passengers
  //     } else if (selectedAdminMarkup.service_type === "percentage") {
  //       // If admin markup is percentage
  //       const percentageFee =
  //         (baseFare * parseFloat(selectedAdminMarkup.service_fee)) / 100 * 2; // Double the fee
  //       updatedFare += percentageFee; // Add percentage fee for all passengers
  //     }
  //   }
  
  //   return parseInt(updatedFare);
  // };
  // const calculateFareForTax = (baseFare, markups, totalPassengers, flightCode) => {
  //   const flightType = "international";
  
  //   // Find applicable agent and admin markups
  //   const applicableAgentMarkups = markups.agent?.filter(
  //     (markup) => markup.flight_type === flightType
  //   ) || [];
  
  //   const applicableAdminMarkups = markups.admin?.filter(
  //     (markup) => markup.flight_type === flightType
  //   ) || [];
  
  //   // Find airline-specific and general markups
  //   const airlineWiseAgentMarkup = applicableAgentMarkups.find(
  //     (markup) =>
  //       markup.markup_type === "airline_wise" && markup.flight_code === flightCode
  //   );
  
  //   const airlineWiseAdminMarkup = applicableAdminMarkups.find(
  //     (markup) =>
  //       markup.markup_type === "airline_wise" && markup.flight_code === flightCode
  //   );
  
  //   const generalAgentMarkup = applicableAgentMarkups.find(
  //     (markup) => markup.markup_type === "all"
  //   );
  
  //   const generalAdminMarkup = applicableAdminMarkups.find(
  //     (markup) => markup.markup_type === "all"
  //   );
  
  //   // Prioritize airline-wise markup, then general markup
  //   const selectedAgentMarkup = airlineWiseAgentMarkup || generalAgentMarkup;
  //   const selectedAdminMarkup = airlineWiseAdminMarkup || generalAdminMarkup;
  
  //   if (!selectedAgentMarkup && !selectedAdminMarkup) {
  //     console.warn(`No markup found for flight type: ${flightType}`);
  //     return baseFare; // No markup found, just return the base fare
  //   }
  
  //   let updatedFare = baseFare; // Keep the base fare unchanged initially
  
  //   // Apply agent markup if available
  //   if (selectedAgentMarkup) {
  //     if (selectedAgentMarkup.service_type === "percentage") {
  //       // If agent markup is percentage
  //       const percentageFee =
  //         (baseFare * parseFloat(selectedAgentMarkup.service_fee)) / 100 * 2; // Double the fee
  //       updatedFare += percentageFee; // Add percentage fee for all passengers
  //     } else if (selectedAgentMarkup.service_type === "fixed") {
  //       // If agent markup is fixed, return the previous amount (baseFare)
  //       updatedFare = baseFare;
  //     }
  //   }
  
  //   // Apply admin markup if available
  //   if (selectedAdminMarkup) {
  //     if (selectedAdminMarkup.service_type === "percentage") {
  //       // If admin markup is percentage
  //       const percentageFee =
  //         (baseFare * parseFloat(selectedAdminMarkup.service_fee)) / 100 * 2; // Double the fee
  //       updatedFare += percentageFee; // Add percentage fee for all passengers
  //     } else if (selectedAdminMarkup.service_type === "fixed") {
  //       // If admin markup is fixed, return the previous amount (baseFare)
  //       updatedFare = baseFare;
  //     }
  //   }
  
  //   return parseInt(updatedFare);
  // };
  
  const calculateFare = (baseFare, markups, totalPassengers, flightCode) => {
    const flightType = "international";
  
    const applicableAgentMarkups = markups?.agent?.filter(
      (markup) => markup.flight_type === flightType
    ) || [];
  
    const applicableAdminMarkups = markups?.admin?.filter(
      (markup) => markup.flight_type === flightType
    ) || [];
  
    if (
      (applicableAgentMarkups.length === 0 && applicableAdminMarkups.length === 0)
    ) {
      console.warn(`No applicable markups found for flight type: ${flightType}`);
      return baseFare;
    }
  
    const airlineWiseAgentMarkup = applicableAgentMarkups.find(
      (markup) =>
        markup.markup_type === "airline_wise" && markup.flight_code === flightCode
    );
  
    const airlineWiseAdminMarkup = applicableAdminMarkups.find(
      (markup) =>
        markup.markup_type === "airline_wise" && markup.flight_code === flightCode
    );
  
    const generalAgentMarkup = applicableAgentMarkups.find(
      (markup) => markup.markup_type === "all"
    );
  
    const generalAdminMarkup = applicableAdminMarkups.find(
      (markup) => markup.markup_type === "all"
    );
  
    const selectedAgentMarkup = airlineWiseAgentMarkup || generalAgentMarkup;
    const selectedAdminMarkup = airlineWiseAdminMarkup || generalAdminMarkup;
  
    let updatedFare = baseFare;
  
    if (selectedAgentMarkup) {
      if (selectedAgentMarkup.service_type === "fixed") {
        const totalServiceFee =
          parseFloat(selectedAgentMarkup.service_fee) * totalPassengers * 2; // Double the fixed fee
        updatedFare += totalServiceFee;
      } else if (selectedAgentMarkup.service_type === "percentage") {
        const percentageFee =
          (baseFare * parseFloat(selectedAgentMarkup.service_fee)) / 100; // Double the percentage fee
        updatedFare += percentageFee;
      }
    }
  
    if (selectedAdminMarkup) {
      if (selectedAdminMarkup.service_type === "fixed") {
        const totalServiceFee =
          parseFloat(selectedAdminMarkup.service_fee) * totalPassengers * 2; // Double the fixed fee
        updatedFare += totalServiceFee;
      } else if (selectedAdminMarkup.service_type === "percentage") {
        const percentageFee =
          (baseFare * parseFloat(selectedAdminMarkup.service_fee)) / 100; // Double the percentage fee
        updatedFare += percentageFee;
      }
    }
  
    return parseInt(updatedFare);
  };
  
  const calculateFares = (baseFare, markups, totalPassengers, flightCode) => {
    const flightType = "international";
  
    // Find applicable agent and admin markups
    const applicableAgentMarkups = markups.agent?.filter(
      (markup) => markup.flight_type === flightType
    ) || [];
  
    const applicableAdminMarkups = markups.admin?.filter(
      (markup) => markup.flight_type === flightType
    ) || [];
  
    // Find airline-specific and general markups
    const airlineWiseAgentMarkup = applicableAgentMarkups.find(
      (markup) =>
        markup.markup_type === "airline_wise" && markup.flight_code === flightCode
    );
  
    const airlineWiseAdminMarkup = applicableAdminMarkups.find(
      (markup) =>
        markup.markup_type === "airline_wise" && markup.flight_code === flightCode
    );
  
    const generalAgentMarkup = applicableAgentMarkups.find(
      (markup) => markup.markup_type === "all"
    );
  
    const generalAdminMarkup = applicableAdminMarkups.find(
      (markup) => markup.markup_type === "all"
    );
  
    // Prioritize airline-wise markup, then general markup
    const selectedAgentMarkup = airlineWiseAgentMarkup || generalAgentMarkup;
    const selectedAdminMarkup = airlineWiseAdminMarkup || generalAdminMarkup;
  
    if (!selectedAgentMarkup && !selectedAdminMarkup) {
      console.warn(`No markup found for flight type: ${flightType}`);
      return baseFare; // No markup found, just return the base fare
    }
  
    let updatedFare = baseFare; // Keep the base fare unchanged initially
  
    // Apply agent markup if available
    if (selectedAgentMarkup) {
      if (selectedAgentMarkup.service_type === "fixed") {
        // If agent markup is fixed
        const totalServiceFee =
          parseFloat(selectedAgentMarkup.service_fee) * totalPassengers * 2; // Double the fixed fee
        updatedFare += totalServiceFee; // Add total service fee for all passengers
      } else if (selectedAgentMarkup.service_type === "percentage") {
        // If agent markup is percentage
        const percentageFee =
          (baseFare * parseFloat(selectedAgentMarkup.service_fee)) / 100; // Double the percentage fee
        updatedFare += percentageFee; // Add percentage fee for all passengers
      }
    }
  
    // Apply admin markup if available
    if (selectedAdminMarkup) {
      if (selectedAdminMarkup.service_type === "fixed") {
        // If admin markup is fixed
        const totalServiceFee =
          parseFloat(selectedAdminMarkup.service_fee) * totalPassengers * 2; // Double the fixed fee
        updatedFare += totalServiceFee; // Add total service fee for all passengers
      } else if (selectedAdminMarkup.service_type === "percentage") {
        // If admin markup is percentage
        const percentageFee =
          (baseFare * parseFloat(selectedAdminMarkup.service_fee)) / 100; // Double the percentage fee
        updatedFare += percentageFee; // Add percentage fee for all passengers
      }
    }
  
    return parseInt(updatedFare);
  };
  
  const calculateFareForTax = (baseFare, markups, totalPassengers, flightCode) => {
    const flightType = "international";
  
    // Find applicable agent and admin markups
    const applicableAgentMarkups = markups.agent?.filter(
      (markup) => markup.flight_type === flightType
    ) || [];
  
    const applicableAdminMarkups = markups.admin?.filter(
      (markup) => markup.flight_type === flightType
    ) || [];
  
    // Find airline-specific and general markups
    const airlineWiseAgentMarkup = applicableAgentMarkups.find(
      (markup) =>
        markup.markup_type === "airline_wise" && markup.flight_code === flightCode
    );
  
    const airlineWiseAdminMarkup = applicableAdminMarkups.find(
      (markup) =>
        markup.markup_type === "airline_wise" && markup.flight_code === flightCode
    );
  
    const generalAgentMarkup = applicableAgentMarkups.find(
      (markup) => markup.markup_type === "all"
    );
  
    const generalAdminMarkup = applicableAdminMarkups.find(
      (markup) => markup.markup_type === "all"
    );
  
    // Prioritize airline-wise markup, then general markup
    const selectedAgentMarkup = airlineWiseAgentMarkup || generalAgentMarkup;
    const selectedAdminMarkup = airlineWiseAdminMarkup || generalAdminMarkup;
  
    if (!selectedAgentMarkup && !selectedAdminMarkup) {
      console.warn(`No markup found for flight type: ${flightType}`);
      return baseFare; // No markup found, just return the base fare
    }
  
    let updatedFare = baseFare; // Keep the base fare unchanged initially
  
    // Apply agent markup if available
    if (selectedAgentMarkup) {
      if (selectedAgentMarkup.service_type === "percentage") {
        // If agent markup is percentage
        const percentageFee =
          (baseFare * parseFloat(selectedAgentMarkup.service_fee)) / 100; // Double the percentage fee
        updatedFare += percentageFee; // Add percentage fee
      } else if (selectedAgentMarkup.service_type === "fixed") {
        // If agent markup is fixed, return the previous amount (baseFare)
        updatedFare = baseFare;
      }
    }
  
    // Apply admin markup if available
    if (selectedAdminMarkup) {
      if (selectedAdminMarkup.service_type === "percentage") {
        // If admin markup is percentage
        const percentageFee =
          (baseFare * parseFloat(selectedAdminMarkup.service_fee)) / 100; // Double the percentage fee
        updatedFare += percentageFee; // Add percentage fee
      } else if (selectedAdminMarkup.service_type === "fixed") {
        // If admin markup is fixed, return the previous amount (baseFare)
        updatedFare = baseFare;
      }
    }
  
    return parseInt(updatedFare);
  };
  
  const calculateFareDeduct = (baseFare, markups, totalPassengers, flightCode) => {
    const flightType = "international";
  
    const applicableAdminMarkups = markups?.admin?.filter(
      (markup) => markup.flight_type === flightType
    ) || [];
  
    if (applicableAdminMarkups.length === 0) {
      console.warn(`No applicable admin markups found for flight type: ${flightType}`);
      return baseFare;
    }
  
    const airlineWiseAdminMarkup = applicableAdminMarkups.find(
      (markup) =>
        markup.markup_type === "airline_wise" && markup.flight_code === flightCode
    );
  
    const generalAdminMarkup = applicableAdminMarkups.find(
      (markup) => markup.markup_type === "all"
    );
  
    const selectedAdminMarkup = airlineWiseAdminMarkup || generalAdminMarkup;
  
    let updatedFare = baseFare;
  
    if (selectedAdminMarkup) {
      if (selectedAdminMarkup.service_type === "fixed") {
        const totalServiceFee =
          parseFloat(selectedAdminMarkup.service_fee) * totalPassengers * 2; // Double the fixed fee
        updatedFare += totalServiceFee;
      } else if (selectedAdminMarkup.service_type === "percentage") {
        const percentageFee =
          (baseFare * parseFloat(selectedAdminMarkup.service_fee)) / 100; // Double the percentage fee
        updatedFare += percentageFee;
      }
    }
  
    return parseInt(updatedFare);
  };
  















  const handleTicketBook = async () => {
    function generateUUID() {
      const timestamp = new Date().getTime().toString(16); // Convert timestamp to hexadecimal
      const randomChars =
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*";
      let randomString = "";

      for (let i = 0; i < 8; i++) {
        randomString += randomChars.charAt(
          Math.floor(Math.random() * randomChars.length)
        );
      }

      return `${timestamp}-${randomString}`;
    }

    let isFirstAdult = true;

    const adultPassengers = formData.map((data, index) => {
      const isLeadPax = isFirstAdult;
      isFirstAdult = false;
      return {
        Title: data.title,
        FirstName: data.firstName,
        LastName: data.lastName,
        PaxType: 1,
        DateOfBirth: data.date,
        Gender: data.title.toLowerCase() === "mr" ? "M" : "F",
        PassportNo: data.passport || null,
        PassportExpiry: data.expirydate,
         ContryCode: data.nationality,
        ContactNo: walletDataa.Phone,
        Email: walletDataa.Email,
        SeatCode: "",
        BaggageCode: "",
        MealCode: "",
        PaxFare: {
          BaseFare: flight[0].PexFareDetails[0].BaseFare * 1.0 + 0.0,
          TaxFare: flight[0].PexFareDetails[0].TaxFare * 1.0,

          YQTax: flight[0].PexFareDetails[0].YQTax * 1.0,
          PriceBaggage: 0.0 * 1.0,
          PriceMeal: 0.0 * 1.0,
          PriceSeat: 0.0 * 1.0,
        },
        IsLeadPax: isLeadPax,
        TicketNumber: null,
      };
    });
    const adjustPaxFareForMultiplePassengers = (passenger) => {
      if (flight[0].PexFareDetails[0].TotPax > 1) {
        const divisor = flight[0].PexFareDetails[0].TotPax;
        const adjustedPaxFare = {
          BaseFare: flight[0].PexFareDetails[0].BaseFare / divisor,
          TaxFare: flight[0].PexFareDetails[0].TaxFare / divisor,

          YQTax: flight[0].PexFareDetails[0].YQTax / divisor,
          PriceBaggage: 0.0,
          PriceMeal: 0.0,
          PriceSeat: 0.0,
        };

        return {
          ...passenger,
          PaxFare: adjustedPaxFare,
        };
      } else {
        return passenger;
      }
    };

    let isChildAdult = true;
    const childPassengers = childData.map((data) => {
      const isLeadPax = isChildAdult;
      isChildAdult = false;
      return {
        Title:
          data.title === "Mr" || data.title === "Mrs" ? "Mstr" : data.title,
        FirstName: data.firstName,
        LastName: data.lastName,
        PaxType: 2,
        DateOfBirth: data.date,
        Gender: data.title.toLowerCase() === "mr" ? "M" : "F",
        PassportNo: data.passport || null,
        PassportExpiry: data.expirydate || null,
        ContryCode: data.nationality,
        ContactNo: walletDataa.Phone,
        Email: walletDataa.Email,
        SeatCode: "",
        BaggageCode: "",
        MealCode: "",
        PaxFare: {
          BaseFare: flight[0].PexFareDetails[1].BaseFare * 1.0,
          TaxFare: flight[0].PexFareDetails[1].TaxFare * 1.0,

          YQTax: flight[0].PexFareDetails[1].YQTax * 1.0,
          PriceBaggage: 0.0 * 1.0,
          PriceMeal: 0.0 * 1.0,
          PriceSeat: 0.0 * 1.0,
        },
        IsLeadPax: isLeadPax,
        TicketNumber: null,
      };
    });
    const adjustPaxFareForMultiplePassengersChild = (passenger) => {
      if (flight[0].PexFareDetails[1].TotPax > 1) {
        const divisor = flight[0].PexFareDetails[1].TotPax;
        const adjustedPaxFare = {
          BaseFare: flight[0].PexFareDetails[1].BaseFare / divisor,
          TaxFare: flight[0].PexFareDetails[1].TaxFare / divisor,

          YQTax: flight[0].PexFareDetails[1].YQTax / divisor,
          PriceBaggage: 0.0,
          PriceMeal: 0.0,
          PriceSeat: 0.0,
        };

        return {
          ...passenger,
          PaxFare: adjustedPaxFare,
        };
      } else {
        return passenger;
      }
    };

    let isInfantAdult = true;
    const infantPassengers = infant.map((data) => {
      const isLeadPax = isInfantAdult;
      isInfantAdult = false;
      return {
        Title:
          data.title === "Mr" || data.title === "Mrs" ? "Mstr" : data.title,
        FirstName: data.firstName,
        LastName: data.lastName,
        PaxType: 3,
        DateOfBirth: data.date,
        Gender: data.title.toLowerCase() === "mr" ? "M" : "F",
        PassportNo: data.passport,
        PassportExpiry: data.expirydate,
        ContryCode: data.nationality,
        ContactNo: walletDataa.Phone,
        Email: walletDataa.Email,
        SeatCode: "",
        BaggageCode: "",
        MealCode: "",
        PaxFare: {
          BaseFare: flight[0].PexFareDetails[2].BaseFare * 1.0,
          TaxFare: flight[0].PexFareDetails[2].TaxFare * 1.0,

          YQTax: flight[0].PexFareDetails[2].YQTax * 1.0,
          PriceBaggage: 0.0 * 1.0,
          PriceMeal: 0.0 * 1.0,
          PriceSeat: 0.0 * 1.0,
        },
        IsLeadPax: isLeadPax,
        TicketNumber: null,
      };
    });
    const adjustPaxFareForMultiplePassengersInfant = (passenger) => {
      if (flight[0].PexFareDetails[2].TotPax > 1) {
        const divisor = flight[0].PexFareDetails[2].TotPax;
        const adjustedPaxFare = {
          BaseFare: flight[0].PexFareDetails[2].BaseFare / divisor,
          TaxFare: flight[0].PexFareDetails[2].TaxFare / divisor,

          YQTax: flight[0].PexFareDetails[2].YQTax / divisor,
          PriceBaggage: 0.0,
          PriceMeal: 0.0,
          PriceSeat: 0.0,
        };

        return {
          ...passenger,
          PaxFare: adjustedPaxFare,
        };
      } else {
        return passenger;
      }
    };

    let preferenceIndex = 0; // Initialize a counter for the preference index

    const allPassengers = [
      ...adultPassengers.map((passenger) => {
        const adjustedPassenger = adjustPaxFareForMultiplePassengers(passenger);
        return {
          ...passenger,
          PaxFare: adjustedPassenger.PaxFare, // Update PaxFare with adjusted values
        };
      }),
      // ...adultPassengers.map((passenger) => {
      //   const mealPreference = passengerMealPreferences[preferenceIndex]
      //     ? [passengerMealPreferences[preferenceIndex]]
      //     : null;
      //   const baggagePreference = passengerBaggagePreferences[preferenceIndex]
      //     ? [passengerBaggagePreferences[preferenceIndex]]
      //     : null;
      //   const seatPreference = passengerSeatPreferences[preferenceIndex]
      //     ? [passengerSeatPreferences[preferenceIndex]]
      //     : null;
      //   preferenceIndex++;
      //   return {

      //   };
      // }),
      ...childPassengers.map((passenger) => {
        const adjustedPassenger =
          adjustPaxFareForMultiplePassengersChild(passenger);
        return {
          ...passenger,
          PaxFare: adjustedPassenger.PaxFare, // Update PaxFare with adjusted values
        };
      }),

      ...infantPassengers.map((passenger) => {
        const adjustedPassenger =
          adjustPaxFareForMultiplePassengersInfant(passenger);
        return {
          ...passenger,
          PaxFare: adjustedPassenger.PaxFare, // Update PaxFare with adjusted values
        };
      }),
    ];

    const requestData = {
      // PreferredCurrency: null,
      // ResultIndex: decodedIndex,
      // APIToken: token || tokenss,
      Id:walletData.Email,
      BookingKey: bookingKey || bookingKeyss,
      ContractId: parseInt(decodedIndex),
      AgentId: walletData && walletData.Id,
      Flightpassenger: allPassengers,

      APIGst: null,

      BookingId: generateUUID(),
      IsHoldRequest: false,
      AccountNo: "27",
    };
    console.log("requestData", requestData);
    const apiUrl = "https://admin.yatriservice.com/api/flightbooking";
    const deductUrl = "https://admin.yatriservice.com/api/deduct-wallet-balance";
    
    try {
      setLoading(true);
    
      // Prepare deduction data
      const deductData = {
        AgentEmail: walletData && walletData.Email,
        FlightAmount:
        calculateFareDeduct(flight[0].AirlineFare.NetFare,markups,totalPassengers,flight[0].AirSegments[0][0].AirlineCode),
      };
    
      // Post deduction data to the API
      const deductResponse = await axios.post(deductUrl, deductData);
      console.log("Wallet deduction response:", deductResponse.data);
    
      if (deductResponse.data.success) {
        localStorage.setItem(
          "walletBalance",
          deductResponse.data.data.WalletBalalnce
        );
        localStorage.setItem(
          "CreditLimit",
          deductResponse.data.data.CreditLimit
        );
    
        // Proceed with booking after successful deduction
        try {
          const bookingResponse = await axios.post(apiUrl, requestData);
    
          if (bookingResponse.data.success) {
           
            console.log("LCC Flight ticket booked successfully:", bookingResponse);
    
            sessionStorage.setItem(
              "BookingIdd",
              parseInt(bookingResponse.data.data.flightbook.BookingId, 10)
            );
            sessionStorage.setItem(
              "AirlinePnr",
              bookingResponse.data.data.flightbook.AirlinePnr
            );
            setLoading(false);
            // Redirect to the flight tickets page
            window.location.assign("/agent/flight-tickets");
          } else {
            console.log("LCC ERROR FOUND IN BOOKING:", bookingResponse.data.success);
            console.log("LCC ERROR FOUND IN BOOKING:", bookingResponse);
            setLoading(false);
            toast.error(
              "An error occurred while booking the flight"
            
            );
            window.location.assign("/agent/error")
            // window.location.assign("/agent/error");
          }
        } catch (bookingError) {
          toast.error(
            "An error occurred while booking the flight"
          
          );
          setLoading(false);
          window.location.assign("/agent/error")
          // window.location.assign("/agent/error");
        }
      } else {
        console.error(
          "Failed to deduct amount from wallet:",
          deductResponse.data
        );
        setLoading(false);
        window.location.assign("/agent/error")
        // window.location.assign("/agent/error");
      }
    } catch (deductError) {
      console.error(
        "An error occurred while deducting from the wallet:",
        deductError
      );
      setLoading(false);
      window.location.assign("/agent/error")
      // window.location.assign("/agent/error");
    }
    
   
    // const apiUrl = "https://admin.yatriservice.com/api/flightbooking";
    // const deductData = {
    //   AgentEmail: walletData && walletData.Email,
    //   FlightAmount: flight[0].AirlineFare.NetFare + adminIm + adminIm,
    // };
   
    // const deductUrl =
    //   "https://admin.yatriservice.com/api/deduct-wallet-balance";
   

    // const data = await axios.post(apiUrl, requestData);
    // if (data) {
    //   console.log("LCC Flight ticket booked successfully:", data);

    //   const respons = await axios.post(deductUrl, deductData);
    //   if (respons) {
    //     console.log("DEDUCT AMT DATA", respons.data.data.WalletBalalnce);
    //     localStorage.setItem("walletBalance", respons.data.data.WalletBalalnce);
    //     localStorage.setItem("CreditLimit", respons.data.data.CreditLimit);
    //   }
    //   sessionStorage.setItem(
    //     "BookingIdd",
    //     parseInt(data.data.data.flightbook.BookingId)
    //   );
    //   sessionStorage.setItem(
    //     "AirlinePnr",
    //     data.data.data.flightbook.AirlinePnr
    //   );
    //   window.location.assign("/agent/flight-tickets");
    // } else {
    //   console.log("LCC ERROR FOUND IN BOOKING");
    // }
  };

  const [walletDataa, setWalletDataa] = useState({
    Phone: walletData.Phone,
    Email: walletData.Email,
  });

  const handleDataUpdate = (updatedData) => {
    setWalletDataa((prevData) => ({
      ...prevData,
      ...updatedData,
    }));
  };

  const handleChangeFlight = () => {
    navigate(-1);
  };
  const validatePassengerData = () => {
    // Define the required fields for each passenger type
    const requiredFields = ["title", "firstName", "lastName"];
    const passportFields = ["passport", "issuedate", "expirydate"];

    // Check if passport details are mandatory
    // const isPassportMandatory =
    //   flight.PricedItinerary.IsPassportIssueDateMandatory ||
    //   flight.PricedItinerary.IsPassportMandatory ||
    //   flight.PricedItinerary.IsPassportNameWithSpace;

    // Helper function to check if an object has all required fields filled
    const isValid = (data, index, type) => {
      for (const field of requiredFields) {
        if (!data[field] || data[field].trim() === "") {
          alert(`Please fill out the ${field} for ${type} ${index + 1}`);
          return false;
        }
      }
      // Check for passport fields if they are mandatory
      // if (isPassportMandatory) {
      //   for (const field of passportFields) {
      //     if (!data[field] || data[field].trim() === "") {
      //       alert(`Please fill out the ${field} for ${type} ${index + 1}`);
      //       return false;
      //     }
      //   }
      // }
      return true;
    };

    // Check if data is present for all passengers
    const adultCount = flight[0] && flight[0].PexFareDetails[0].TotPax;
    const childCount = flight[0].PexFareDetails[1]
      ? flight[0].PexFareDetails[1].TotPax
      : 0;

    const infantCount = flight[0].PexFareDetails[2]
      ? flight[0].PexFareDetails[2].TotPax
      : 0;

    // Validate adult data
    if (formData.length !== adultCount) {
      alert(`Please fill out details for all ${adultCount} adults`);
      return false;
    }
    for (let i = 0; i < formData.length; i++) {
      if (!isValid(formData[i], i, "adult")) return false;
    }

    // Validate child data
    if (childData.length !== childCount) {
      alert(`Please fill out details for all ${childCount} children`);
      return false;
    }
    for (let i = 0; i < childData.length; i++) {
      if (!isValid(childData[i], i, "child")) return false;
    }

    // Validate infant data
    if (infant.length !== infantCount) {
      alert(`Please fill out details for all ${infantCount} infants`);
      return false;
    }
    for (let i = 0; i < infant.length; i++) {
      if (!isValid(infant[i], i, "infant")) return false;
    }

    return true;
  };
  console.log("flightttttttttttt", flight);


 const [showModal, setShowModal] = useState(false);
    const [confirmed, setConfirmed] = useState(false);
    const handleShowModal = () => {
      // Show the modal when the "Pay Now" button is clicked
      setShowModal(true);
      setOpenPayBtn(false);
    };
    
    const handleConfirmModal = () => {
      // After confirming in the modal, set the Pay button to true
      setOpenPayBtn(true);
      handleCloseModal();  // Close the modal
    };
  // Function to open the modal when the button is clicked
  // const handleShowModal = () => {
  //   setShowModal(true);
  // };
  
  // // Function to confirm the payment and proceed with the booking
  // const handleConfirmBooking = () => {
  //   setConfirmed(true);
  //   // Call the booking logic here (e.g., handleTicketBook)
  //   handleTicketBook();
  //   setShowModal(false);
  // };
  
  // Function to close the modal if the user cancels
  const handleCloseModal = () => {
    setShowModal(false);
  };
  
 


  return (
    <div className="roundtrippg">
      <div style={{ position: "relative" }}>
        <Container className="flightBookingMainMain">
          <Row>
            <Col md={9}>
              <div className="booking_title">
                <h3> Review Your Booking</h3>
                <Link
                  className="change_flight"
                  onClick={() => handleChangeFlight()}
                >
                  Change Flight
                </Link>
              </div>
              {/* {flight2 && <DepatureDetail flight={flight2} type="Return" />} */}
              {flight ? (
                <DepatureDetail
                  fareRule={fareRule}
                  flight={flight}
                  type="Departure"
                  fareActive={fareActive}
                  setFareActive={setFareActive}
                />
              ) : (
                <FlightDetailSkeleton />
              )}

              <Row>
                <Col md={12} xs={12}>
                  <div
                    id="TRAVELLER_DETAIL"
                    className="oneCard-element"
                    style={{ marginTop: "20px" }}
                  >
                    <div className="componentContainer ">
                      <div className="paxd">
                        <TravellerInformation
                          flight={flight}
                          handleInputChange={handleInputChange}
                          handleInputChange1={handleInputChange1}
                          handleInputChange2={handleInputChange2}
                          handleExpiryDateChange={handleExpiryDateChange}
                          handleExpiryDateChange1={handleExpiryDateChange1}
                          handleExpiryDateChange2={handleExpiryDateChange2}
                          handleDOBChange={handleDOBChange}
                          handleDOBChange1={handleDOBChange1}
                          handleDOBChange2={handleDOBChange2}
                          formData={formData}
                          childData={childData}
                          infant={infant}
                        />
                      </div>
                    </div>
                  </div>

                  {/* <div
                    className="componentContainer "
                    style={{ padding: "10px 10px", marginBottom: "20px" }}
                  >
                    <div className="myseatinfo">
                      <div className="booking_title">
                        <h3>Addon Services</h3>
                      </div>
                      <div
                        className="block-content-2 custom_block_content"
                        style={{ border: "none", boxShadow: "none" }}
                      >
                        {flight && (
                          <div
                            className="box-result custom_box_result"
                            style={{ display: "flex" }}
                          >
                            <div
                              className="ssrtabs ssrlists"
                              style={{ maxHeight: "400px" }}
                            >
                              <p className="fw-bold mb-2">Select Passenger</p>
                              <Nav variant="tabs" role="tablist">
                                {passengers &&
                                  passengers.map((passenger, index) => (
                                    <Nav.Item key={index}>
                                      <Nav.Link
                                        id={`passenger-tab${index}`}
                                        eventKey={index}
                                        active={index === activeTab}
                                        onClick={() => handleTabChange(index)}
                                      >
                                        <div className="d-flex">
                                          <span className="asradio"></span>{" "}
                                          <label htmlFor={`rdbSSR_${index}`}>
                                            {passenger.type} {passenger.id}
                                          </label>
                                          <tt id={`adultName_${index}`}>
                                           
                                          </tt>
                                        </div>
                                        <ul
                                          className="ssrtabstabs_itinerary"
                                          style={{ padding: "0px" }}
                                        >
                                          <li style={{ marginRight: 5 }}>
                                            <span className="icon">
                                              <i
                                                className="fa fa-suitcase"
                                                aria-hidden="true"
                                              ></i>
                                            </span>
                                            <tt id={`bagdetail_${index}`}>0</tt>{" "}
                                            kg
                                          </li>
                                          <li style={{ marginRight: 5 }}>
                                            <span className="icon">
                                              <i
                                                className="fa fa-cutlery"
                                                aria-hidden="true"
                                              ></i>
                                            </span>
                                            <tt id={`mealdetail_${index}`}>
                                              0
                                            </tt>{" "}
                                            Platter
                                          </li>
                                          <li style={{ marginRight: 5 }}>
                                            <span className="icon">
                                              <i
                                                className="fa fa-chair"
                                                aria-hidden="true"
                                              ></i>
                                            </span>
                                            <tt id={`seatdetail_${index}`}>
                                              {" "}
                                              No Seat
                                            </tt>
                                            <tt
                                              id={`seatdetailinput_${index}`}
                                            ></tt>
                                          </li>
                                        </ul>
                                      </Nav.Link>
                                    
                                    </Nav.Item>
                                  ))}
                               
                              </Nav>
                            </div>
                           
                            <div className="ssr_content tab-content">
                              {passengers.map((passenger, index) => (
                                <SSRContent
                                  // srdvIdx={srdvIdx}
                                  key={index}
                                  index={index}
                                  passenger={passenger}
                                  passengers={passengers}
                                  activeTab={activeTab}
                                  ssrResponse={ssrResponse}
                                  ssrResponse2={ssrResponse2}
                                  // handleChangeCurrency={handleChangeCurrency}
                                  passengerBaggagePreferences={
                                    passengerBaggagePreferences
                                  }
                                  setPassengerBaggagePreferences={
                                    setPassengerBaggagePreferences
                                  }
                                  passengerMealPreferences={
                                    passengerMealPreferences
                                  }
                                  setPassengerMealPreferences={
                                    setPassengerMealPreferences
                                  }
                                  passengerSeatPreferences={
                                    passengerSeatPreferences
                                  }
                                  setPassengerSeatPreferences={
                                    setPassengerSeatPreferences
                                  }
                                />
                              ))}
                            </div>
                            
                          </div>
                        )}
                      </div>
                    </div>
                  </div> */}

                  <BDSend
                    walletData={walletDataa}
                    onUpdate={handleDataUpdate}
                  />
                </Col>
              </Row>
            </Col>
            {!flight2 && (
              <PriceDetail
                flight={flight}
                walletDatas={walletDatas}
                setShowdetail={setShowdetail}
                adminIm={adminIm}
                agentIm={agentIm}
                creditLimits={creditLimits}
                internationalMarkup={internationalMarkup}
                showdetail={showdetail}
                walletData={walletData}
                setOpenPayBtn={setOpenPayBtn}
                openPayBtn={openPayBtn}
                passengerSeatPreferences={passengerSeatPreferences}
                passengerMealPreferences={passengerMealPreferences}
                passengerBaggagePreferences={passengerBaggagePreferences}
                validatePassengerData={validatePassengerData}
                markups={markups}
                calculateFares={calculateFares}
                totalPassengers={totalPassengers}
                calculateFare={calculateFare}
                calculateFareForTax={calculateFareForTax}
                calculateFareDeduct={calculateFareDeduct}
              />
            )}
          </Row>
        </Container>
        {openPayBtn ? (
          <div
            style={{
              position: "absolute",
              width: "100%",
              top: "0px",
              height: "100%",
              zIndex: "10",
            }}
          >
            <FlightPayModal
              flight={flight}
              openPayBtn={openPayBtn}
              setOpenPayBtn={setOpenPayBtn}
              formData={formData}
              childData={childData}
              walletDatas={walletDatas}
              adminIm={adminIm}
              agentIm={agentIm}
              internationalMarkup={internationalMarkup}
              infant={infant}
              handleTicketBook={handleTicketBook}
              passengerSeatPreferences={passengerSeatPreferences}
              passengerMealPreferences={passengerMealPreferences}
              passengerBaggagePreferences={passengerBaggagePreferences}
              loading={loading}
              markups={markups}
              calculateFares={calculateFares}
              totalPassengers={totalPassengers}
              calculateFare={calculateFare}
              calculateFareForTax={calculateFareForTax}
              calculateFareDeduct={calculateFareDeduct}
              handleShowModal={handleShowModal}
            />
          </div>
        ) : (
          ""
        )}
      </div>

      <div
        style={{
          textAlign: "center",
          position: "sticky",
          bottom: "0px",
          backgroundImage: "linear-gradient(90deg, #8b3eea 20%, #530597 40%, #2b2540 90%)",
          // backgroundImage: "linear-gradient(to right, #DA22FF 0%, #9733EE 51%, #DA22FF 100%)",
          color: "#fff",
          paddingBlock: "3px",
          fontSize: "12px",
          letterSpacing: "3px",
        }}
      >
        {timer.minutes !== null
          ? `${timer.minutes} minutes ${timer.seconds} seconds`
          : "loading..."}
      </div>

      <Modal show={showsessionModal} onHide={handleOk} centered>
        <Modal.Body className="text-center">
          <FaClock size={50} style={{ color: "#8b3eea" }} />
          <h4 className="mt-3">Your session is expired</h4>
          <p>Click OK to continue with a new search</p>
          <Button
            variant="primary"
            onClick={handleOk}
            style={{
              background: "#8b3eea",
              border: "none",
              padding: "10px 20px",
              fontSize: "16px",
            }}
          >
            OK
          </Button>
        </Modal.Body>
      </Modal>


      <div className="confirmation_modalsssss">
    <Modal show={showModal} onHide={handleCloseModal} size="lg">
  <Modal.Header closeButton>
    <Modal.Title>Confirm & Edit Your Details</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <div className="passenger-detailssssss">
     
      {formData.map((data, index) => (
  <React.Fragment key={index}>
    <Col sm={12} className="passport_field" style={{backgroundImage:'linear-gradient(to right, rgb(221, 200, 255) 0%, rgb(250, 248, 255) 51%, rgb(245 236 249) 100%)',padding:'10px'}}>
    <div className="form_field_col2">
          <div className="contact_label cus_label ontact_label_bfswif" style={{marginBottom:'0px'}}>
            <Form.Label>Adults {index + 1}</Form.Label>
          </div>
        </div>
      <div style={{ marginBottom: "5px" }}>
        
      <Row>
          <Col md={4} className="form_field form_select_fieldssssss">
            <div className="cus_field_input cus_select_titlessssss">
           
              <Form.Control
                as="select"
                name={`title${index}`}
                className="title form-control commoninputreset"
                onChange={(e) => handleInputChange(index, e)}
                autoComplete="off"
                value={data.title || ""}
              >
                <option>Title</option>
                <option value="Mr">Mr.</option>
                <option value="Ms">Ms.</option>
                <option value="Mrs">Mrs.</option>
              </Form.Control>
            </div>
            <div className="cus_field_input cus_name_fieldssss">
            <Form.Label className="travellers-service-form-controll">
                Title & First Name
              </Form.Label>
              <Form.Control
                type="text"
                name={`firstName${index}`}
                placeholder="First Name"
                className="form-control firstname commoninputreset"
                onChange={(e) => handleInputChange(index, e)}
                value={data.firstName || ""}
                autoComplete="off"
              />
            </div>
          </Col>
          <Col className="form_field" md={4}>
            <div className="cus_field_input cus_name_field">
              <Form.Label className="travellers-service-form-controll">
                Last Name
              </Form.Label>
              <Form.Control
                type="text"
                name={`lastName${index}`}
                placeholder="Last Name"
                className="form-control firstname commoninputreset"
                onChange={(e) => handleInputChange(index, e)}
                value={data.lastName || ""}
                autoComplete="off"
              />
            </div>
          </Col>
          <Col md={4}>
          <div className="date_field">
            <div className="cus_field_input" style={{ marginTop: "20px" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Date of Birth"
                  name={`date${index}`}
                  value={
                    data.date ? dayjs(data.date) : null
                  }
                  onChange={(newValue) => {
                    const syntheticEvent = {
                      target: {
                        name: `date${index}`,
                        value: newValue?.format("YYYY-MM-DD") || "",
                      },
                    };
                    handleInputChange(index, syntheticEvent);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      placeholder="Date of Birth"
                      autoComplete="off"
                      style={{ height: "20px", color: "#000" }}
                      className="commoninputreset form-control datepicker-infant-time-start hasDatepicker"
                    />
                  )}
                />
              </LocalizationProvider>
            </div>
          </div>
          </Col>
          </Row>
      
        
      </div>


        <div>
           
          {/* <Col sm={2} className="form_field_col2">
            <div className="contact_label cus_label">
              <Form.Label>Passport Detail</Form.Label>
            </div>
          </Col> */}
         <Row>
            <Col lg={4} className="form_field">
              <div className="cus_field_input cus_name_field">
                <Form.Label className="travellers-service-form-controll">
                  Passport Number
                </Form.Label>
                <Form.Control
                  type="text"
                  name={`passport${index}`}
                  placeholder="Passport No."
                  className="form-control firstname commoninputreset"
                  value={data.passport || ""}
                  onChange={(e) => handleInputChange(index, e)}
                  autoComplete="off"
                />
              </div>
            </Col>

            <Col lg={4} className="date_field">
              <div className="cus_field_input" style={{ marginTop: "25px" }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="Expiry Date"
                    name={`expiryDate${index}`} // Dynamically set the name
                    value={
                      data.expirydate
                        ? dayjs(data.expirydate, "DD-MM-YYYY")
                        : null // Convert string to dayjs object with the correct format
                    }
                    onChange={(newValue) => {
                      // Create a synthetic event to match handleInputChange's expected input
                      const syntheticEvent = {
                        target: {
                          name: `expiryDate${index}`,
                          value: newValue?.format("DD-MM-YYYY") || "", // Format as DD-MM-YYYY
                        },
                      };
                      handleInputChange(index, syntheticEvent);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        placeholder="Expiry Date"
                        autoComplete="off"
                        style={{ height: "auto" }}
                        inputProps={{
                          ...params.inputProps,
                          min: new Date().toISOString().split("T")[0], // Set min to today's date
                        }}
                        className="commoninputreset form-control datepicker-infant-time-start hasDatepicker"
                      />
                    )}
                  />
                </LocalizationProvider>
              </div>
            </Col>

            <Col lg={4}  className="date_field">
              <div className="cus_field_input ">
                <Form.Label className="travellers-service-form-controll" style={{ marginLeft: '10px' }}>
                  Select Country
                </Form.Label>
                <Form.Control
                  as="select"
                  name={`nationality${index}`}
                  className="title form-control commoninputreset selection_country_Ccode_Travell"
                  onChange={(e) => handleInputChange(index, e)}
                  value={data.nationality || ""}
                  autoComplete="off"
                >
                  <option value="Nationality">Nationality</option>
                  {countries.map((country, idx) => (
                    <option key={idx} value={country.Code}>
                      {country.Name}
                    </option>
                  ))}
                </Form.Control>
              </div>
            </Col>
            </Row>
        </div>

    </Col>
  </React.Fragment>
))}
     
      

      {childData.map((data, index) => (
  <React.Fragment key={index}>
    <Col sm={12} className="passport_field"  style={{backgroundImage:'linear-gradient(to right, rgb(221, 200, 255) 0%, rgb(250, 248, 255) 51%, rgb(245 236 249) 100%)',padding:'10px'}}>
    <div className="form_field_col2">
          <div className="contact_label cus_label ontact_label_bfswif" style={{marginBottom:'0px'}}>
            <Form.Label>Child {index + 1}</Form.Label>
          </div>
        </div>
      <div style={{ marginBottom: "5px" }}>
        
      <Row>
          <Col md={4} className="form_field form_select_fieldssssss">
            <div className="cus_field_input cus_select_titlessssss">
           
              <Form.Control
                as="select"
                name={`title${index}`}
                className="title form-control commoninputreset"
                onChange={(e) => handleInputChange1(index, e)}
                autoComplete="off"
                value={data.title || ""}
              >
                <option>Title</option>
                <option value="Mr">Mr.</option>
                <option value="Ms">Ms.</option>
                <option value="Mrs">Mrs.</option>
              </Form.Control>
            </div>
            <div className="cus_field_input cus_name_fieldssss">
            <Form.Label className="travellers-service-form-controll">
                Title & First Name
              </Form.Label>
              <Form.Control
                type="text"
                name={`firstName${index}`}
                placeholder="First Name"
                className="form-control firstname commoninputreset"
                onChange={(e) => handleInputChange1(index, e)}
                value={data.firstName || ""}
                autoComplete="off"
              />
            </div>
          </Col>
          <Col className="form_field" md={4}>
            <div className="cus_field_input cus_name_field">
              <Form.Label className="travellers-service-form-controll">
                Last Name
              </Form.Label>
              <Form.Control
                 type="text"
                 name={`lastName${index}`}
                 placeholder="Last Name"
                 className="form-control firstname commoninputreset"
                 onChange={(e) => handleInputChange1(index, e)}
                 value={data.lastName || ""}
                 autoComplete="off"
              />
            </div>
          </Col>
          <Col md={4}>
          <div className="date_field">
            <div className="cus_field_input" style={{ marginTop: "20px" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                  label="Date of Birth"
                  name={`date${index}`}
                  value={data.date ? dayjs(data.date) : null}
                  onChange={(newValue) => {
                    const syntheticEvent = {
                      target: {
                        name: `date${index}`,
                        value: newValue?.format("YYYY-MM-DD") || "",
                      },
                    };
                    handleInputChange1(index, syntheticEvent);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      placeholder="Date of Birth"
                      autoComplete="off"
                      style={{ height: "20px", color: "#000" }}
                      className="commoninputreset form-control datepicker-infant-time-start hasDatepicker"
                    />
                  )}
                />
              </LocalizationProvider>
            </div>
          </div>
          </Col>
          </Row>
      
        
      </div>


        <div>
           
          {/* <Col sm={2} className="form_field_col2">
            <div className="contact_label cus_label">
              <Form.Label>Passport Detail</Form.Label>
            </div>
          </Col> */}
         <Row>
            <Col lg={4} className="form_field">
              <div className="cus_field_input cus_name_field">
                <Form.Label className="travellers-service-form-controll">
                  Passport Number
                </Form.Label>
                <Form.Control
                  type="text"
                  name={`passport${index}`}
                  placeholder="Passport No."
                  className="form-control firstname commoninputreset"
                  value={data.passport || ""}
                  onChange={(e) => handleInputChange1(index, e)}
                  autoComplete="off"
                />
              </div>
            </Col>

            <Col lg={4} className="date_field">
              <div className="cus_field_input" style={{ marginTop: "25px" }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                    label="Expiry Date"
                    name={`expirydate${index}`}
                    value={
                      data.expirydate
                        ? dayjs(data.expirydate, "DD-MM-YYYY")
                        : null
                    }
                    onChange={(newValue) => {
                      const syntheticEvent = {
                        target: {
                          name: `expirydate${index}`,
                          value: newValue?.format("DD-MM-YYYY") || "",
                        },
                      };
                      handleInputChange1(index, syntheticEvent);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        placeholder="Expiry Date"
                        autoComplete="off"
                        style={{ height: "auto" }}
                        inputProps={{
                          ...params.inputProps,
                          min: new Date().toISOString().split("T")[0],
                        }}
                        className="commoninputreset form-control datepicker-infant-time-start hasDatepicker"
                      />
                    )}
                  />
                </LocalizationProvider>
              </div>
            </Col>

            <Col lg={4}  className="date_field">
              <div className="cus_field_input ">
                <Form.Label className="travellers-service-form-controll" style={{ marginLeft: '10px' }}>
                  Select Country
                </Form.Label>
                <Form.Control
                  as="select"
                  name={`nationality${index}`}
                  className="title form-control commoninputreset selection_country_Ccode_Travell"
                  onChange={(e) => handleInputChange1(index, e)}
                  value={data.nationality || ""}
                  autoComplete="off"
                >
                  <option value="Nationality">Nationality</option>
                  {countries.map((country, idx) => (
                    <option key={idx} value={country.Code}>
                      {country.Name}
                    </option>
                  ))}
                </Form.Control>
              </div>
            </Col>
            </Row>
        </div>
  
    </Col>
  </React.Fragment>
))}






      {infant.map((data, index) => (
  <React.Fragment key={index}>
    <Col sm={12} className="passport_field" style={{backgroundImage:'linear-gradient(to right, rgb(221, 200, 255) 0%, rgb(250, 248, 255) 51%, rgb(245 236 249) 100%)',padding:'10px'}}>
    <div className="form_field_col2">
          <div className="contact_label cus_label ontact_label_bfswif" style={{marginBottom:'0px'}}>
            <Form.Label>Infant {index + 1}</Form.Label>
          </div>
        </div>
      <div style={{ marginBottom: "5px" }}>
        
      <Row>
          <Col md={4} className="form_field form_select_fieldssssss">
            <div className="cus_field_input cus_select_titlessssss">
           
              <Form.Control
                as="select"
                name={`title${index}`}
                className="title form-control commoninputreset"
                onChange={(e) => handleInputChange2(index, e)}
                autoComplete="off"
                value={data.title || ""}
              >
                <option>Title</option>
                <option value="Mr">Mr.</option>
                <option value="Ms">Ms.</option>
                <option value="Mrs">Mrs.</option>
              </Form.Control>
             
            </div>
            <div className="cus_field_input cus_name_fieldssss">
            <Form.Label className="travellers-service-form-controll">
                Title & First Name
              </Form.Label>
              <Form.Control
              type="text"
              name={`firstName${index}`}
              placeholder="First Name"
              className="form-control firstname commoninputreset"
              onChange={(e) => handleInputChange2(index, e)}
              value={data.firstName || ""}
              autoComplete="off"
              />
            </div>
          </Col>
          <Col className="form_field" md={4}>
            <div className="cus_field_input cus_name_field">
              <Form.Label className="travellers-service-form-controll">
                Last Name
              </Form.Label>
              <Form.Control
                  type="text"
                  name={`lastName${index}`}
                  placeholder="Last Name"
                  className="form-control firstname commoninputreset"
                  onChange={(e) => handleInputChange2(index, e)}
                  value={data.lastName || ""}
                  autoComplete="off"
              />
            </div>
          </Col>
          <Col md={4}>
          <div className="date_field">
            <div className="cus_field_input" style={{ marginTop: "20px" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                    label="Date of Birth"
                    name={`date${index}`}
                    value={data.date ? dayjs(data.date) : null}
                    onChange={(newValue) => {
                      const syntheticEvent = {
                        target: {
                          name: `date${index}`,
                          value: newValue?.format("YYYY-MM-DD") || "",
                        },
                      };
                      handleInputChange2(index, syntheticEvent);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        placeholder="Date of Birth"
                        autoComplete="off"
                        style={{ height: "20px", color: "#000" }}
                        className="commoninputreset form-control datepicker-infant-time-start hasDatepicker"
                      />
                    )}
                  />
              </LocalizationProvider>
            </div>
          </div>
          </Col>
          </Row>
      
        
      </div>


        <div>
           
          {/* <Col sm={2} className="form_field_col2">
            <div className="contact_label cus_label">
              <Form.Label>Passport Detail</Form.Label>
            </div>
          </Col> */}
         <Row>
            <Col lg={4} className="form_field">
              <div className="cus_field_input cus_name_field">
                <Form.Label className="travellers-service-form-controll">
                  Passport Number
                </Form.Label>
                <Form.Control
                   type="text"
                   name={`passport${index}`}
                   placeholder="Passport No."
                   className="form-control firstname commoninputreset"
                   value={data.passport || ""}
                   onChange={(e) => handleInputChange2(index, e)}
                   autoComplete="off"
                />
              </div>
            </Col>

            <Col lg={4} className="date_field">
              <div className="cus_field_input" style={{ marginTop: "25px" }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                    label="Expiry Date"
                    name={`expirydate${index}`}
                    value={
                      data.expirydate
                        ? dayjs(data.expirydate, "DD-MM-YYYY")
                        : null
                    }
                    onChange={(newValue) => {
                      const syntheticEvent = {
                        target: {
                          name: `expirydate${index}`,
                          value: newValue?.format("DD-MM-YYYY") || "",
                        },
                      };
                      handleInputChange2(index, syntheticEvent);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        placeholder="Expiry Date"
                        autoComplete="off"
                        style={{ height: "auto" }}
                        inputProps={{
                          ...params.inputProps,
                          min: new Date().toISOString().split("T")[0],
                        }}
                        className="commoninputreset form-control datepicker-infant-time-start hasDatepicker"
                      />
                    )}
                  />
                </LocalizationProvider>
              </div>
            </Col>

            <Col lg={4}  className="date_field">
              <div className="cus_field_input ">
                <Form.Label className="travellers-service-form-controll" style={{ marginLeft: '10px' }}>
                  Select Country
                </Form.Label>
                <Form.Control
                   as="select"
                   name={`nationality${index}`}
                   className="title form-control commoninputreset selection_country_Ccode_Travell"
                   onChange={(e) => handleInputChange2(index, e)}
                   value={data.nationality || ""}
                   autoComplete="off"
                 >
                   <option value="Nationality">Nationality</option>
                   {countries.map((country, idx) => (
                     <option key={idx} value={country.Code}>
                       {country.Name}
                     </option>
                   ))}
                </Form.Control>
              </div>
            </Col>
            </Row>
        </div>
 
    </Col>
  </React.Fragment>
))}

    </div>
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={handleCloseModal}>
      Cancel
    </Button>
    <Button variant="primary" onClick={handleConfirmModal} style={{padding:"8px 25px"}}>
     Submit
    </Button>
  </Modal.Footer>
</Modal>
    </div>

      
    </div>
  );
};

export default FlightInternationalDetail;
